import { useCachedFlag, type CachedFlag } from '../providers/CachedFlagsProvider'

export default function useContributionChangeLogFlag(): CachedFlag<'contributionChangeLog'> {
  return useCachedFlag('contributionChangeLog')
}
